import React from "react";
import logo from "../images/logo.png";
import SpecialLink from "./SpecialLink";

const Banner = React.forwardRef(({ language }, ref) => {
  return (
    <section ref={ref} id="banner">
      <div className="inner">
        <h2
          style={{
            textAlign: "center"
          }}
        >
          <img
            style={{
              maxHeight: "110px",
              minHeight: "85px"
            }}
            src={logo}
          />
        </h2>
        <div
          style={{
            float: "right"
          }}
        >
          <SpecialLink to="About">
            {language === "en" ? "About us" : "Nosotros"}
          </SpecialLink>
        </div>
      </div>
    </section>
  );
});

export default Banner;



// WEBPACK FOOTER //
// ./src/components/Banner.js